var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Page-1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.408,
    height: 21.44,
    viewBox: "0 0 22.408 21.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "superado-limite-de-descargas-usuario"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "corona"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-29",
    width: 18.069,
    height: 4.192,
    transform: "translate(2.336 17.248)",
    fill: "#fa8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M1.377,13.985,10.46.061l9.248,13.923Z",
    transform: "translate(0.719 -0.061)",
    fill: "#ff8c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M18.691,14.766l2.114-12.3L2.822,14.28Z",
    transform: "translate(1.602 1.41)",
    fill: "#eda500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    d: "M2.1,14.715.075,2.433l16.8,12.282Z",
    transform: "translate(-0.075 1.387)",
    fill: "#fec400"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/goldIcon.23f7b285c4fbe744730bdbad83619cb8.svg";
export { ForwardRef as ReactComponent };